/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const UserSettings32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801a5.452 5.452 0 002.269-2.27c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlDarkBlue}
        />
        <path
            d="M14.5 15a3.37 3.37 0 001.755-.471 3.59 3.59 0 001.269-1.273A3.445 3.445 0 0018 11.463c0-.64-.159-1.221-.476-1.744a3.586 3.586 0 00-1.274-1.252A3.4 3.4 0 0014.5 8c-.64 0-1.227.157-1.759.471a3.621 3.621 0 00-1.274 1.256A3.234 3.234 0 0011 11.471c0 .656.157 1.251.472 1.785.314.534.736.958 1.264 1.273A3.387 3.387 0 0014.5 15z"
            fill="#fff"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.765 17c.236 0 .44.17.47.4l.122.827c.147.068.289.148.425.24l.816-.318a.478.478 0 01.574.206l.767 1.29a.469.469 0 01-.122.605l-.677.515a5.24 5.24 0 010 .469l.678.516c.186.142.235.4.117.61l-.76 1.279a.475.475 0 01-.586.207l-.808-.315a3.22 3.22 0 01-.424.24l-.122.823a.47.47 0 01-.47.405h-1.527a.469.469 0 01-.47-.4l-.122-.827a3.062 3.062 0 01-.425-.24l-.816.318a.477.477 0 01-.574-.206l-.767-1.29a.47.47 0 01.122-.605l.676-.515a5.382 5.382 0 010-.469l-.677-.516a.464.464 0 01-.118-.61l.76-1.279a.475.475 0 01.586-.208l.809.316a3.21 3.21 0 01.423-.24l.122-.823a.47.47 0 01.47-.405h1.528zM21 19.285c-.944 0-1.714.77-1.714 1.715A1.715 1.715 0 1021 19.285z"
            fill="#fff"
        />
        <path
            d="M14.266 17c.996 0 1.908.145 2.734.434-.14.113-.26.254-.354.423l-.73 1.268A1.497 1.497 0 0016.219 21a1.504 1.504 0 00-.321 1.841l.006.012.66 1.147h-7.57c-.745 0-1.264-.125-1.556-.374-.292-.25-.438-.598-.438-1.045 0-.597.17-1.217.51-1.862.34-.645.827-1.25 1.462-1.813.635-.564 1.4-1.023 2.293-1.376.893-.353 1.893-.53 3-.53z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default UserSettings32;
